export default __webpack_public_path__ + "static/media/lot.4ead7488.jpg";